
import React from "react";
import ListCountry from "../countries/ListCountry";
import {
  COUNTRY_AFRICAN,
  ITEMS_TO_DISPLAY_SM,
} from "../../../helpers/constants";
import { getSchools } from "../../../services/schoolService";

const StudyList = ({ items, option, selectedContinent, selectedCountries }) => {
  const isNoSchools = items.length === 0
  &&!selectedContinent
  &&!selectedCountries
  &&option.key === COUNTRY_AFRICAN.key;

  

  return (
    <React.Fragment>
      {isNoSchools ? (
        <div className="empty-list text-center">
          <p className="mb-0 p-2">
            {`La liste des pays ${
              option.key !== COUNTRY_AFRICAN.key ? "non" : ""
            } africains bientôt disponible.`}
          </p>
        </div>
      ) : (
        <ListCountry
          items={items.slice(0, ITEMS_TO_DISPLAY_SM)}
          withDiscover={items.length > ITEMS_TO_DISPLAY_SM}
          discoverOptions={{ discoverLink: `#` }}
        />
      )}
    </React.Fragment>
  );
};

export default StudyList;
